export default "__VITE_PUBLIC_ASSET__02434095__"